import React from "react";
import img from "./delete.svg";
import styles from "./index.module.scss";
export default class Delete2 extends React.Component {
    static defaultProps = {
        className: "",
        onClick: () => { },
    };
    render() {
        return (React.createElement("img", { onClick: this.props.onClick, src: img, alt: "Delete2 Icon", className: `${styles.delete2} ${this.props.className}` }));
    }
}
